import React from 'react';
import Router from '../Router';

const Main = () => (
  <main>
    <Router />
  </main>
);

export default Main;
